'use client'

import ArticlesPanel from '@/components/ArticlesPanel'
import { useTopicContext } from './TopicContext'

// Story-page wiring for the shared articles panel: the topic context owns
// which articles are open and the bias-filter state, so a click anywhere on
// the page (counts, angle cards, spectrum dots) drives one panel.
export default function ArticlesModal() {
  const {
    articlesModalOpen,
    articlesModalArticles,
    articlesModalTitle,
    closeArticlesModal,
    biasFilters,
    selectBias,
    topicSlug,
  } = useTopicContext()

  return (
    <ArticlesPanel
      isOpen={articlesModalOpen}
      onClose={closeArticlesModal}
      title={articlesModalTitle}
      articles={articlesModalArticles}
      biasFilters={biasFilters}
      selectBias={selectBias}
      storySlug={topicSlug}
    />
  )
}
